/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Automix_Threshold_HelpInputs */

const en_audio_description_export_automix_threshold_help = /** @type {(inputs: Audio_Description_Export_Automix_Threshold_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume level that triggers ducking (lower = more sensitive)`)
};

const fr_audio_description_export_automix_threshold_help = /** @type {(inputs: Audio_Description_Export_Automix_Threshold_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau de volume qui déclenche l'atténuation (plus bas = plus sensible)`)
};

const de_audio_description_export_automix_threshold_help = /** @type {(inputs: Audio_Description_Export_Automix_Threshold_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lautstärkepegel, der das Ducking auslöst (niedriger = empfindlicher)`)
};

const it_audio_description_export_automix_threshold_help = /** @type {(inputs: Audio_Description_Export_Automix_Threshold_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livello del volume che attiva il ducking (più basso = più sensibile)`)
};

const ru_audio_description_export_automix_threshold_help = /** @type {(inputs: Audio_Description_Export_Automix_Threshold_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уровень громкости, запускающий эффект приглушения (чем ниже уровень, тем выше чувствительность).`)
};

const es_audio_description_export_automix_threshold_help = /** @type {(inputs: Audio_Description_Export_Automix_Threshold_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nivel de volumen que activa el ducking (más bajo = más sensible)`)
};

const zh_cn2_audio_description_export_automix_threshold_help = /** @type {(inputs: Audio_Description_Export_Automix_Threshold_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`触发闪避的音量级别（越低越敏感）`)
};

const ja_audio_description_export_automix_threshold_help = /** @type {(inputs: Audio_Description_Export_Automix_Threshold_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダッキングをトリガーする音量レベル（低いほど感度が高い）`)
};

const hi_audio_description_export_automix_threshold_help = /** @type {(inputs: Audio_Description_Export_Automix_Threshold_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आवाज का वह स्तर जो झुकने को प्रेरित करता है (कम आवाज = अधिक संवेदनशीलता)`)
};

const pt_pt2_audio_description_export_automix_threshold_help = /** @type {(inputs: Audio_Description_Export_Automix_Threshold_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nível de volume que aciona o mecanismo de abaixamento (menor = maior sensibilidade)`)
};

/**
* | output |
* | --- |
* | "Volume level that triggers ducking (lower = more sensitive)" |
*
* @param {Audio_Description_Export_Automix_Threshold_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_threshold_help = /** @type {((inputs?: Audio_Description_Export_Automix_Threshold_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_Threshold_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_automix_threshold_help(inputs)
	if (locale === "de") return de_audio_description_export_automix_threshold_help(inputs)
	if (locale === "it") return it_audio_description_export_automix_threshold_help(inputs)
	if (locale === "ru") return ru_audio_description_export_automix_threshold_help(inputs)
	if (locale === "es") return es_audio_description_export_automix_threshold_help(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_automix_threshold_help(inputs)
	if (locale === "ja") return ja_audio_description_export_automix_threshold_help(inputs)
	if (locale === "hi") return hi_audio_description_export_automix_threshold_help(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_automix_threshold_help(inputs)
	return en_audio_description_export_automix_threshold_help(inputs)
});